module.exports = __webpack_public_path__ + "static/media/numberplate.e4d62874.jpg";